import styled from 'styled-components'
import { colors } from "../../branding";


export const StyledPageHome = styled.main`
  .PageHome-card-deck {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    flex-wrap: wrap;
    
    a {
      min-width: 46%;
      width: 46%;
      max-width: 500px;
      padding: 20px;
      box-sizing: border-box;
      margin: 10px 0;
      color: ${colors.black};
      text-decoration: none;
      border: 1px solid rgba(0,0,0,.125);
      border-radius: .25rem;
      box-shadow: 0 .5rem 1rem rgba(0,0,0,.15);
      transition: all .2s ease-in-out;
      
      h2 {
        font-size: 36px;
        text-align: left;
        margin: 0;
        color: ${colors.blueDark};
      }
      
      strong {
        font-size: 16px;
        font-family: 'Exo', sans-serif;
      }
      
      div {
        margin-top: 20px;
      }
      
      :hover {
        transform: scale(1.1);
       z-index: 200;
      }
    }
  }

  @media (max-width: 600px) {
    .PageHome-card-deck {
      flex-direction: column;
      align-items: center;
      
      
      a {
        width: 90%;
        max-width: 90%;
        
        
        h2 {
          font-size: 18px;
        }
      }
    }
  }
`

export const StyledPageStandardSection = styled.section`
  display: flex;
  flex-direction: column;
  
  h2, h3, h4, h5, h6 {
    color: ${colors.blueDark}
  }
    
  img {
    align-self: center;
  }
`
